import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Platform } from '@app/classes';
import { FeatureFlag } from '@app/enums';
import { AdminGuard, CompanyModuleGuard, FeatureGuard, PermissionGuard } from '@app/guards';
import { RoutesWithOptions } from '@app/interfaces';
import { Asset } from '@app/models/company/asset.model';
import { KYCKYBPreRedirectView } from '@app/views/kyc-kyb/kyc-kyb.view';
import { CompanyResolver } from '@company/company.resolver';
import {
    AssetsCategoriesIndexView,
    AssetsIndexView,
    AssetsShowView,
    AssetsStoreView,
    CalendarFeedIndexView,
    OfficeIndexView,
    OfficeShowView,
    OverviewShowView,
    PositionIndexView,
    PositionShowView,
} from '@company/views';

const routes: RoutesWithOptions = [
    { path: '', pathMatch: 'full', redirectTo: 'overview' },

    // Overview
    { path: 'overview', component: OverviewShowView },
    // Offices
    { path: 'offices', component: OfficeIndexView },
    {
        path: 'offices/:office',
        component: OfficeShowView,
        resolve: {
            models: CompanyResolver,
        },
    },
    // positions
    { path: 'positions', component: PositionIndexView },
    {
        path: 'positions/:position',
        component: PositionShowView,
        resolve: {
            models: CompanyResolver,
        },
    },
    { path: 'calendar-feeds', component: CalendarFeedIndexView },
    {
        path: 'import',
        loadChildren: () => import('@import/import.module').then((m) => m.ImportModule),
    },
    // Assets
    {
        path: 'assets',
        component: AssetsIndexView,
        canActivate: [PermissionGuard],
        data: { permission: [Asset.managePermission] },
    },
    {
        path: 'assets/new',
        component: AssetsStoreView,
        canActivate: [PermissionGuard],
        data: { permission: [Asset.managePermission] },
    },
    {
        path: 'assets/:asset',
        component: AssetsShowView,
        canActivate: [PermissionGuard],
        data: { permission: [Asset.managePermission] },
        resolve: {
            models: CompanyResolver,
        },
    },
    {
        path: 'assets/:asset/edit',
        component: AssetsStoreView,
        canActivate: [PermissionGuard],
        data: { permission: [Asset.managePermission] },
        resolve: {
            models: CompanyResolver,
        },
    },
    {
        path: 'asset-categories',
        component: AssetsCategoriesIndexView,
        canActivate: [PermissionGuard],
        data: { permission: [Asset.managePermission] },
    },
    {
        path: 'verify-your-business',
        component: KYCKYBPreRedirectView,
        canActivate: [PermissionGuard, FeatureGuard, AdminGuard, CompanyModuleGuard],
        data: {
            permission: 'accessPayroll',
            feature: { flags: [FeatureFlag.KYC_KYB] },
            scope: 'KYB',
            companyModule: Platform.modules.payroll,
        },
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class CompanyRouterModule {}
